/***
*
*   ACCOUNT NAV
*   Acount sub nav that renders different options based
*   on user permissions. Shows billing & user admin to only account owners
*
**********/

import React from 'react';
import { NavLink } from "react-router-dom";
import FeatherIcon from 'feather-icons-react';
import 'components/nav.scss';

export default function CloseNav(props){

  return(
    <nav className='subnav'>
      {/* <NavLink exact to='/client/work/close/1' activeClassName='active'>
        <FeatherIcon icon="check-square" size={16} className="icon" /> Close Checklist
      </NavLink> */}
      <NavLink exact to='/client/work/cleanup' activeClassName='active'>
        <FeatherIcon icon="layout" size={16} className="icon" /> Data Clean-Up
      </NavLink>
      {/* <NavLink exact to='/app/glMonitors' activeClassName='active'>
        <FeatherIcon icon="layout" size={16} className="icon" /> GL Review
      </NavLink> */}
      <NavLink exact to='/client/work/reports' activeClassName='active'>
        <FeatherIcon icon="layout" size={16} className="icon" /> Reports
      </NavLink>
    </nav>
  );
}
